@for (error of displayedErrors(); track error) {
    <span class="errorMessage">{{ error.errorMessage }}</span>
}
